import { decodeWeddingAbroad } from './services'

const getDefaultState = () => {
  return {
    displayPricing: false,
    isWeddingAbroad: false,
    bookingNumber: null,
    bookingName: null
  }
}

const state = getDefaultState()
const getters = {
  isWeddingAbroad: (state) => {
    return state.isWeddingAbroad
  },
  displayPricing: (state) => {
    return state.displayPricing
  }
}
const actions = {
  async decodeWeddingUNID  ({ dispatch, commit }, unid) {
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const result = await decodeWeddingAbroad(unid)
    dispatch('spinner/updateLoadingAction', false, { root: true })

    if (result.data) {
      commit('decodedData', result.data)
    }
  }
}

const mutations = {
  decodedData (state, data) {
    state.isWeddingAbroad = true
    state.bookingNumber = data.bookno
    state.bookingName = data.surname
    if (data.cost === 'true') {
      state.displayPricing = true
    }
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
